import { render, staticRenderFns } from "./errDataTipModal.vue?vue&type=template&id=3875cb4e&scoped=true"
import script from "./errDataTipModal.vue?vue&type=script&lang=js"
export * from "./errDataTipModal.vue?vue&type=script&lang=js"
import style0 from "./errDataTipModal.vue?vue&type=style&index=0&id=3875cb4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3875cb4e",
  null
  
)

export default component.exports